// extracted by mini-css-extract-plugin
export default {"column":"Column_column__ugnTi"};